import { render, staticRenderFns } from "./ChatModule.vue?vue&type=template&id=5449972c&scoped=true"
import script from "./ChatModule.vue?vue&type=script&lang=js"
export * from "./ChatModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449972c",
  null
  
)

export default component.exports